<ng-container *ngIf="item.isShown">

    <!-- item.url -->
    <a #navLink1 class="nav-link" [ngClass]="item.classes" *ngIf="item.url && !item.externalUrl && !item.function"
        [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
        [routerLinkActiveOptions]="{exact: item.exactMatch || false}" [target]="item.openInNewTab ? '_blank' : '_self'">
        <span class="nav-link-ripple" matRipple [matRippleTrigger]="navLink1" [matRippleCentered]="true" [matRippleAnimation]="{enterDuration: 400, exitDuration: 400}"></span>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.externalUrl -->
    <a #navLink2 class="nav-link" [ngClass]="item.classes" *ngIf="item.url && item.externalUrl && !item.function"
        [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'">
        <span class="nav-link-ripple" matRipple [matRippleTrigger]="navLink2" [matRippleCentered]="true" [matRippleAnimation]="{enterDuration: 400, exitDuration: 400}"></span>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.function -->
    <span #navLink3 class="nav-link" [ngClass]="item.classes" *ngIf="!item.url && item.function" (click)="item.function()" (keydown.enter)="item.function()">
        <span class="nav-link-ripple" matRipple [matRippleTrigger]="navLink3" [matRippleCentered]="true" [matRippleAnimation]="{enterDuration: 400, exitDuration: 400}"></span>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>

    <!-- item.url && item.function (logout) -->
    <a #navLink4 class="nav-link" [ngClass]="item.classes" *ngIf="item.url && !item.externalUrl && item.function"
        (click)="logout()">
        <span class="nav-link-ripple" matRipple [matRippleTrigger]="navLink4" [matRippleCentered]="true" [matRippleAnimation]="{enterDuration: 400, exitDuration: 400}"></span>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.externalUrl && item.function -->
    <a #navLink5 class="nav-link" [ngClass]="item.classes" *ngIf="item.url && item.externalUrl && item.function"
        (click)="item.function()" [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'">
        <span class="nav-link-ripple" matRipple [matRippleTrigger]="navLink5" [matRippleCentered]="true" [matRippleAnimation]="{enterDuration: 400, exitDuration: 400}"></span>
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <ng-template #itemContent>
        <mat-icon class="nav-link-icon" *ngIf="item.icon && item.iconType=='material'">{{item.icon}}</mat-icon>
        <!-- <span class="nav-link-icon {{item.icon}}" *ngIf="item.icon && item.iconType !='material'"></span> -->
        <i-feather class="h-20 w-20 nav-link-icon" name="{{item.icon}}" *ngIf="item.icon && item.iconType !='material'"></i-feather>

        <span class="nav-link-title">{{item.translate | translate}}</span>
        <span class="nav-link-badge" *ngIf="item.badge" [translate]="item.badge.translate"
            [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
            {{item.badge.title}}
        </span>
    </ng-template>

</ng-container>
